import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen bg-gradient-to-b from-zyp-cream to-zyp-white text-zyp-navy flex items-center justify-center px-6"
    >
      <div className="max-w-md text-center">
        <div className="font-heading text-7xl md:text-8xl font-semibold tracking-tighter text-zyp-highlight">
          404
        </div>
        <h1 className="mt-6 font-heading text-3xl font-medium tracking-tight">
          Page not found.
        </h1>
        <p className="mt-4 text-zyp-navy/70">
          Looks like that page took a detour. Let&rsquo;s get you back home.
        </p>
        <Link to="/">
          <Button
            data-testid="not-found-home-cta"
            className="mt-8 bg-zyp-highlight hover:bg-zyp-highlight-hover text-white rounded-full px-7 h-12"
          >
            Back to Zyp
          </Button>
        </Link>
      </div>
    </div>
  );
}
